export const MESSAGING_STAFF_SCOPE_ADMIN = "administradores";
export const MESSAGING_DIRECTOR_SCOPE_USERS = "usuarios";
export const MESSAGING_DIRECTOR_SCOPE_ADMINS = "administradores";
export const MESSAGING_DIRECTOR_SCOPE_COURSES = "cursos";

/**
 * @param {unknown} value
 * @returns {string}
 */
export function normalizeMongoId(value) {
  if (value == null || value === "") return "";
  if (typeof value === "string") return value.trim();
  if (typeof value === "number" || typeof value === "boolean" || typeof value === "bigint") {
    return String(value);
  }
  if (typeof value === "object" && value !== null) {
    if (typeof value.$oid === "string") return value.$oid;
    if (value._id != null) return normalizeMongoId(value._id);
    if (typeof value.id === "string") return value.id;
    return "";
  }
  return "";
}

/**
 * @param {string | null | undefined} filtro
 * @returns {boolean}
 */
export function isMessagingCourseScope(filtro) {
  const id = normalizeMongoId(filtro);
  return id.length === 24 && /^[a-f0-9]{24}$/i.test(id);
}

/**
 * @param {Array<{ _id?: string }>} cursos
 * @param {{ urlCursoId?: string | null; activeCourseId?: string | null }} [options]
 * @returns {string | null}
 */
export function pickInstructorDefaultCursoId(cursos, options = {}) {
  const ids = (cursos ?? [])
    .map((c) => normalizeMongoId(c._id))
    .filter(Boolean);
  if (ids.length === 0) {
    return null;
  }

  const urlId = normalizeMongoId(options.urlCursoId);
  if (urlId && ids.includes(urlId)) {
    return urlId;
  }

  const activeId = normalizeMongoId(options.activeCourseId);
  if (activeId && ids.includes(activeId)) {
    return activeId;
  }

  return ids[0];
}

/**
 * @param {string} rol
 * @returns {boolean}
 */
export function isInstructorMessagingRole(rol) {
  return String(rol ?? "").trim() === "instructor";
}

/**
 * @param {string} cursoId
 * @param {Array<{ _id?: string }>} cursosAsignados
 * @returns {boolean}
 */
export function instructorHasAssignedCourse(cursoId, cursosAsignados) {
  const target = normalizeMongoId(cursoId);
  if (!target) {
    return false;
  }
  return (cursosAsignados ?? []).some(
    (c) => normalizeMongoId(c._id) === target,
  );
}

/**
 * @param {unknown} cursosInscritos
 * @returns {Array<{ _id: string; titulo: string }>}
 */
export function mapPerfilCursosToBasicList(cursosInscritos) {
  if (!Array.isArray(cursosInscritos)) {
    return [];
  }
  const rows = [];
  for (const entry of cursosInscritos) {
    if (entry && typeof entry === "object") {
      const id = normalizeMongoId(entry._id);
      if (!id) {
        continue;
      }
      const titulo =
        typeof entry.titulo === "string" && entry.titulo.trim() !== ""
          ? entry.titulo.trim()
          : "";
      rows.push({ _id: id, titulo });
      continue;
    }
    const id = normalizeMongoId(entry);
    if (id) {
      rows.push({ _id: id, titulo: "" });
    }
  }
  return rows;
}

/**
 * @param {string | null | undefined} cursoSeleccionado
 * @returns {"all" | "alumno"}
 */
export function resolveInstructorContactRoleFilter(cursoSeleccionado) {
  if (cursoSeleccionado === MESSAGING_STAFF_SCOPE_ADMIN) {
    return "all";
  }
  if (isMessagingCourseScope(cursoSeleccionado)) {
    return "alumno";
  }
  return "all";
}

/**
 * @param {string | null | undefined} directorScope
 * @returns {"alumno" | "staff"}
 */
export function resolveDirectorContactRoleFilter(directorScope) {
  if (directorScope === MESSAGING_DIRECTOR_SCOPE_ADMINS) {
    return "staff";
  }
  return "alumno";
}
